import React, { useEffect, useState} from 'react';
import { Input } from 'tea-component';
import classNames from 'classnames';
import { IFilterListProps } from '../../_type';
import './index.scss';

// 组装接口配置和页面配置的相关信息传递给子组件 ，如：nameEn、nameCn、formatter、width、tooltipEn、tooltipCn等
const FilterInputText = (props: IFilterListProps) => {
  const { selectedRadio, value: valueProps, onChange } = props;
  const { errorReg = /^\d*$/, errorMsg: propsErrorMsg = 'dbb_input_error',  startText= '', endText='', value: inputRadioValue } = selectedRadio || {};
  const [value, setValue] = useState(valueProps);
  const [errorMsg, setErrorMsg] = useState('');
  // 外部受控值
  useEffect(() => {
    setValue(valueProps);
  }, [valueProps]);

  const handleChange = (val: string) => {
    setValue(val);
    let newErrorMsg = errorMsg;
    if (!errorReg.test(val)) {
      newErrorMsg = propsErrorMsg;
    } else if (inputRadioValue === 'percent' && Number(val || 0) > 100) {
      newErrorMsg = 'dbb_input_percent_max';
    } else {
      newErrorMsg = '';
    }
    setErrorMsg(newErrorMsg);
    // 没有最小值，注意最小值0和''是有区别的
    onChange({ max: val, min: '', errorMsg: newErrorMsg });
  };
  
  return  <div className='dbb-range-selector-filter-input-text'>
    {
      startText &&<div className='dbb-range-selector-filter-input-text-start'>{startText}</div>
    }
    <Input
      className={classNames(
        'dbb-range-selector-filter-input-text-input',
        {'dbb-range-selector-filter-input-text-input-percent': inputRadioValue === 'percent'},
        {"dbb-range-selector-filter-input-text-is-error": !!errorMsg})
      }
      value={value}
      onChange={handleChange}/>
    {
      endText &&<div  className='dbb-range-selector-filter-input-text-end'>{endText}</div>
    }
  </div>;
};

export default FilterInputText;
